export default __webpack_public_path__ + "static/media/sanmar14.a7dc849f.jpg";